module.exports = __webpack_public_path__ + "img/home-projects.f9271d8f.svg";